import createAction from '../services/create-action';

export const START_EDITING_COMMENT = 'comment/START_EDITING';
export const startEditingComment = createAction(START_EDITING_COMMENT);



// WEBPACK FOOTER //
// ./app/actions/start-editing-comment.js